module.exports = __webpack_public_path__ + "assets/img/logo_black.3f5f80e0.png";